import request from '@/api/request'
export default{
    // login:data=>request.post('/users/login',data),
    // getUserInfo:()=>request.get("/users/getUserInfo")
}